var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('basic-loading',{attrs:{"type":'small'}}):_c('button',{staticClass:"circular-check btn-fake",on:{"click":function (ev) { return _vm.$emit('click', ev); }}})}
var staticRenderFns = []

export { render, staticRenderFns }